import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlNavigationService {
  constructor() {}

  openInNewTab(url: string, focus: boolean = false): void {
    const newWindow = window.open(url, '_blank', 'noopener, noreferrer');
    if (newWindow) {
      newWindow.opener = null;

      if (focus) {
        newWindow.focus();
      }
    }
  }

  openInSameTab(url: string): void {
    location.href = url;
  }
}
